import { render } from "./InternationalPayout.vue?vue&type=template&id=b8371e26&scoped=true&ts=true"
import script from "./InternationalPayout.vue?vue&type=script&lang=ts"
export * from "./InternationalPayout.vue?vue&type=script&lang=ts"

import "./InternationalPayout.vue?vue&type=style&index=0&id=b8371e26&scoped=true&lang=css"

import exportComponent from "/Users/thomaswang/Workspace/Latipay/FlashFxUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8371e26"]])

export default __exports__